export default function MobileBar() {
  return (
    <aside className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-foreground-950/95 border-t border-background-50/15 backdrop-blur-md px-4 py-3 shadow-2xl">
      <div className="flex items-center gap-3 max-w-md mx-auto">
        <a
          href="tel:+19544444747"
          className="flex-1 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 text-xs font-semibold py-3 px-3 rounded-md flex items-center justify-center gap-2 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line text-sm text-accent-300" />
          <span>(954) 444-4747</span>
        </a>
        <a
          href="#contact"
          className="flex-1 bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-semibold py-3 px-3 rounded-md flex items-center justify-center gap-1.5 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span>Free Audit</span>
          <i className="ri-arrow-right-line text-sm" />
        </a>
      </div>
    </aside>
  );
}
